import { render, staticRenderFns } from "./regist_rent.vue?vue&type=template&id=58fbff6a&scoped=true"
import script from "./regist_rent.vue?vue&type=script&lang=js"
export * from "./regist_rent.vue?vue&type=script&lang=js"
import style0 from "./regist_rent.vue?vue&type=style&index=0&id=58fbff6a&prod&lang=scss"
import style1 from "./regist_rent.vue?vue&type=style&index=1&id=58fbff6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fbff6a",
  null
  
)

export default component.exports